module.exports = __webpack_public_path__ + "img/tottenham3.97ae0323.jpg";